import { LevelOfService } from '../../timeline/models/enums/level-of-service.enum';

export enum ConsiderationTreatment {
    FaceValueAtClosing = 0,
    CashValueAtReceipt = 1,
    Choice = 2,
    FairValueAtClosing = 3,
}

export const ConsiderationTreatments = [
    {
        id: ConsiderationTreatment.FaceValueAtClosing,
        name: 'Face value at closing',
    },
    {
        id: ConsiderationTreatment.FairValueAtClosing,
        name: 'Fair value at closing',
    },
    {
        id: ConsiderationTreatment.CashValueAtReceipt,
        name: 'Cash value at receipt',
    },
    {
        id: ConsiderationTreatment.Choice,
        name: 'Choice between fair value at close or cash value of consideration at receipt',
    },
];

export const getAllowedConsiderationTreatments = (levelOfService: number) =>
    levelOfService === LevelOfService.DiscountBrokerage
        ? ConsiderationTreatments.filter(
              (treatment) =>
                  treatment.id !== ConsiderationTreatment.FairValueAtClosing &&
                  treatment.id !== ConsiderationTreatment.Choice
          )
        : ConsiderationTreatments;

export const withLegacyTreatment = (
    treatments: typeof ConsiderationTreatments,
    currentValue: ConsiderationTreatment | null | undefined
) => {
    if (currentValue == null || treatments.some((treatment) => treatment.id === currentValue)) {
        return treatments;
    }
    const legacyTreatment = ConsiderationTreatments.find(
        (treatment) => treatment.id === currentValue
    );
    return legacyTreatment ? [...treatments, legacyTreatment] : treatments;
};
